import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { RectangleWithRadius } from "../../utils/RectangleWithRadius";
import { AudioManager } from "../../AudioManager";

export class StatsState extends Phaser.State {

    public static currentInstance: StatsState;

    public create(): void {

        StatsState.currentInstance = this;

        const backgroundImage = this.add.image( GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "lawn-background");
        backgroundImage.anchor.set(.5);
        backgroundImage.scale.setTo(1.65, 1.65 * GameVars.scaleY);

        const backButton = this.add.button(90, GameConstants.GAME_HEIGHT - 130 * GameVars.scaleY, "texture_atlas_5", this.onClickBackButton, this, 1, 0, 1);
        backButton.setFrames("exit_button_on", "exit_button_off", "exit_button_on");
        backButton.anchor.set(.5);
        backButton.scale.y = GameVars.scaleY;

        const scaledItemsContainer = this.add.group();
        scaledItemsContainer.scale.y = GameVars.scaleY;
        
        let rectangleWithRadius = new RectangleWithRadius(this.game, 70 , 20, GameConstants.GAME_WIDTH - 140, 715 , 40,
            "#ffffff", 0.35, null, 3);
        scaledItemsContainer.add(rectangleWithRadius);

        let blackGradientRectangle = new Phaser.Sprite(this.game, 0, 60, this.game.cache.getBitmapData("dark_gradient"));
        blackGradientRectangle.scale.setTo(58 , 1.7);
        scaledItemsContainer.add(blackGradientRectangle);

        let sceneTitleLabel = new Phaser.Text(this.game, 135, 78, " GAME STATS ", {font: "85px whoopass", fill: "#DAE9E9"});
        scaledItemsContainer.add( sceneTitleLabel );

        // las 3 bandas blancas
        let whiteRectangle = new Phaser.Sprite(this.game, 70, 170 + 80, this.game.cache.getBitmapData("white_square"));
        whiteRectangle.scale.setTo( 39.25 , 5);
        whiteRectangle.alpha = .3;
        scaledItemsContainer.add(whiteRectangle);

        whiteRectangle = new Phaser.Sprite(this.game, 70, 170 + 3 * 80, this.game.cache.getBitmapData("white_square"));
        whiteRectangle.scale.setTo( 39.25 , 5);
        whiteRectangle.alpha = .3;
        scaledItemsContainer.add(whiteRectangle);

        whiteRectangle = new Phaser.Sprite(this.game, 70, 170 + 5 * 80, this.game.cache.getBitmapData("white_square"));
        whiteRectangle.scale.setTo( 39.25 , 5);
        whiteRectangle.alpha = .3;
        scaledItemsContainer.add(whiteRectangle);

        this.addDataLabels(scaledItemsContainer);

        this.game.camera.flash(0x000000, 250);
    }

    public shutdown(): void {
        
        StatsState.currentInstance = null;

        super.shutdown();
    }

    public onClickBackButton(): void {
        
        this.game.state.start("SplashState", true, false);
        
        AudioManager.getInstance().playEffect( "play");
    }

    private addDataLabels(scaledItemsContainer: Phaser.Group): void {

        const scoredGoalsString = GameVars.gameData.statsData.scoredGoals.toString();
        const scoredPenaltiesString = GameVars.gameData.statsData.scoredPenalties.toString();
        const matchesWonString = GameVars.gameData.statsData.matchesWon.toString();
        const matchesPlayedString = GameVars.gameData.statsData.matchesPlayed.toString();

        let winningPercentageString: string;

        if (GameVars.gameData.statsData.matchesPlayed > 0) {
            let winningPercentage = Math.floor(100 *  GameVars.gameData.statsData.matchesWon / GameVars.gameData.statsData.matchesPlayed);
            winningPercentageString = winningPercentage.toString() + " %";
        } else {
            winningPercentageString = "-";
        }

        let label = new Phaser.Text(this.game, 95, 252, "SCORED GOALS:", {font: "60px Ubuntu Condensed", fill: "#000000"});
        label.scale.x = .8;
        scaledItemsContainer.add(label);

        label = new Phaser.Text(this.game, 555, 252, scoredGoalsString, {font: "60px Ubuntu Condensed", fill: "#000000"});
        label.scale.x = .8;
        scaledItemsContainer.add(label);

        label = new Phaser.Text(this.game, 95, 252 + 80, "SCORED PENALTIES:", {font: "60px Ubuntu Condensed", fill: "#000000"});
        label.scale.x = .8;
        scaledItemsContainer.add(label);

        label = new Phaser.Text(this.game, 555, 252 + 80, scoredPenaltiesString, {font: "60px Ubuntu Condensed", fill: "#000000"});
        label.scale.x = .8;
        scaledItemsContainer.add(label);

        label = new Phaser.Text(this.game, 95, 252 + 2 * 80, "MATCHES WON:", {font: "60px Ubuntu Condensed", fill: "#000000"});
        label.scale.x = .8;
        scaledItemsContainer.add(label);

        label = new Phaser.Text(this.game, 555, 252 + 2 * 80, matchesWonString, {font: "60px Ubuntu Condensed", fill: "#000000"});
        label.scale.x = .8;
        scaledItemsContainer.add(label);

        label = new Phaser.Text(this.game, 95, 252 + 3 * 80, "MATCHES PLAYED:", {font: "60px Ubuntu Condensed", fill: "#000000"});
        label.scale.x = .8;
        scaledItemsContainer.add(label);

        label = new Phaser.Text(this.game, 555, 252 + 3 * 80, matchesPlayedString, {font: "60px Ubuntu Condensed", fill: "#000000"});
        label.scale.x = .8;
        scaledItemsContainer.add(label);

        label = new Phaser.Text(this.game, 95, 252 + 4 * 80, "WINNING PERCENTAGE:", {font: "60px Ubuntu Condensed", fill: "#000000"});
        label.scale.x = .8;
        scaledItemsContainer.add(label);

        label = new Phaser.Text(this.game, 555, 252 + 4 * 80, winningPercentageString, {font: "60px Ubuntu Condensed", fill: "#000000"});
        label.scale.x = .8;
        scaledItemsContainer.add(label);

        label = new Phaser.Text(this.game, 95, 252 + 5 * 80, "TROPHIES WON:", {font: "60px Ubuntu Condensed", fill: "#000000"});
        label.scale.x = .8;
        scaledItemsContainer.add(label);

        label = new Phaser.Text(this.game, 555, 252 + 5 * 80,  GameVars.getAchievedTrophies().toString(), {font: "60px Ubuntu Condensed", fill: "#000000", align: "center"});
        label.scale.x = .8;
        scaledItemsContainer.add(label);
    }
}
